import { render, staticRenderFns } from "./TableArea.vue?vue&type=template&id=0bfd69af&scoped=true"
import script from "./TableArea.vue?vue&type=script&lang=js"
export * from "./TableArea.vue?vue&type=script&lang=js"
import style0 from "./TableArea.vue?vue&type=style&index=0&id=0bfd69af&prod&lang=less&scoped=true"
import style1 from "./TableArea.vue?vue&type=style&index=1&id=0bfd69af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfd69af",
  null
  
)

export default component.exports